import {CheckboxItem} from "./CheckboxItem";

export default CheckboxItem;